export default __webpack_public_path__ + "static/media/doctor_video_preview.eb588153.webp";